export default __webpack_public_path__ + "static/media/car.b207e79d.gif";